import styled from 'styled-components';

const Deemphasize = styled.span`
  filter: var(--theme-deemphasize-filter);
  font-weight: var(--theme-font-weight);
`;

export default Deemphasize;
